@if (editable()) {
  <div class="flex justify-end mt-[-40px] ">
    <button
      class="bg-ui-gray-100 rounded-lg px-2 h-10 flex items-center justify-center active:bg-ui-green-light"
      (click)="openRemoteActionMenu()"
    >
      <mat-icon class="text-white">add</mat-icon>
    </button>
  </div>
}

@if (!loading()) {
  <ul>
    @for (action of remoteActionList(); track action.id) {
      <li class="mt-2 relative">
        <button
          class="btn-white-stroked w-full flex justify-between p-3"
          (click)="executeAction(action)"
          [disabled]="!twoWayCommunication()"
        >
          <div class="flex flex-col text-left">
            <span
              class="text-sm font-semibold"
              [ngClass]="!twoWayCommunication() ? 'text-ui-gray-750' : 'text-ui-dark'"
            >
              {{ action.name }}
            </span>
            <span class="text-sm remote-parent-device">
              {{ action.device.friendlyName }}
            </span>
          </div>
        </button>

        @if (editable()) {
          <button
            class="btn-white-stroked absolute top-0 right-0 rounded-none px-3 border h-full rounded-tr-lg rounded-br-lg"
            (click)="openRemoteActionMenu(action)"
          >
            <mat-icon class="text-ui-gray-100 active:text-ui-green-light">
              edit
            </mat-icon>
          </button>
        }
      </li>
    } @empty {
      <div class="text-center py-10">
        <img
          class="mx-auto"
          alt="empty list"
          src="assets/icons/empty-action-list-icon.svg"
        >
        <p class="text-xl text-ui-gray-100">No Remote Actions Setup</p>
      </div>
    }
  </ul>
} @else {
  <mat-spinner
    class="mx-auto my-10"
    diameter="80"
  />
}
